// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { Tree } from "metabase/common/components/tree";
import { color } from "metabase/ui/utils/colors";

export const FilterableTreeRoot = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const FilterableTreeContainer = styled.div`
  overflow: auto;
`;

export const FilterInputContainer = styled.div`
  padding: 0.75rem 1.5rem;
`;

export const ItemGroupsDivider = styled.hr`
  margin: 1rem 1.5rem;
  border: 0;
  border-top: 1px solid var(--mb-color-border-neutral);
`;

export const EmptyStateContainer = styled.div`
  margin-top: 6.25rem;
`;

export const AdminTreeNode = styled(Tree.Node)`
  color: ${(props) =>
    // TODO: We should really come up with a better solution for this, but since admin-navbar is currently not determined by
    // user whitelabelling, this is somewhat safe (and consistent with what is in the admin header nav)
    props.isSelected ? "var(--mantine-color-white)" : color("text-secondary")};
  background-color: ${(props) =>
    props.isSelected ? color("navbar-admin") : "unset"};
  /* Otherwise a solid fill distinguished only by color (WCAG 1.4.1) — add
     a real ring so the shape doesn't depend on perceiving the fill's hue. */
  outline: ${(props) =>
    props.isSelected ? "2px solid var(--mantine-color-white)" : "none"};
  outline-offset: -4px;

  &:hover {
    background-color: ${(props) =>
      props.isSelected
        ? color("navbar-admin")
        : color("navbar-admin-secondary")};
  }
`;
